export default "__VITE_ASSET__D93stI_f__"